<div class="w-full md:max-w-md md:mx-auto">
@if (this.isLoader) {
  <app-loader [message]="'Procesando'"></app-loader>
} @else {
  <div class="bg-dark-khaki-50 w-full h-full">
    <div class="mx-auto w-full items-center justify-center text-center p-8">
      @if (isSuccess) {
        @if (data.consumption_id > 0) {
          <div class="w-full bg-vivid-royal-600 p-4 text-md text-white">
            <span>Utiliza este código antes de</span><span class="font-bold ml-1">{{data.expiration_date|date}}</span>
            <span class="text-center block text-lg">CÓDIGO ACTIVO</span>
          </div>
          <div class="grid grid-cols-2 mt-2">
            <div class="rounded-l-lg text-white font-bold px-4 py-2" [ngClass]="{'bg-red-800':data.product_id==2,'bg-green-800':data.product_id==1, 'bg-gray-800':data.product_id==3 }">
              {{ data.product_name ?? "91 Octanos" }}
            </div>
            <div>
              <div class="rounded-r-lg bg-vivid-royal-600 text-white font-bold px-4 py-2">
                @if (data.is_volume == 1) {
                  <span>{{ data!.quantity_requested }} {{ data!.quantity_requested > 1 ? "Lts" : "Lt" }}</span>
                } @else {
                  <span>{{ data!.amount_requested | currency }} Pesos</span>
                }
              </div>
            </div>
          </div>
          <h1 class="text-center text-md font-normal text-gray-900 mt-2">
            Este código se refrescará en {{ timer }} segundos
          </h1>
        }

        <div class="flex justify-center w-full mt-4">
          @if (dataSecure != "") {
            <div class="relative inline-block" style="width:180px;height:180px">
              @if (!qrReady) {
                <div class="absolute inset-0 animate-pulse rounded-lg" style="background:linear-gradient(135deg,#e5e7eb 25%,#f3f4f6 50%,#e5e7eb 75%)"></div>
              }
              <div #qrCanvas></div>
              @if (qrReady) {
                <img src="./assets/logos/energo_qr.gif" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded" />
              }
            </div>
          }
        </div>
        <h1 class="text-center text-md mt-4 text-gray-900">
          Muestra este código a tu asesor de servicio.
        </h1>
        <div class="flex justify-center gap-3 mt-2">
          <div class="flex">
            <div class="rounded-l-lg bg-vivid-royal-800 text-white px-2">Folio</div>
            <div class="rounded-r-lg bg-vivid-royal-500 text-white px-2">{{data.consumption_id}}</div>
          </div>
          <div class="flex">
            <div class="rounded-l-lg bg-vivid-royal-800 text-white px-2">Cliente</div>
            <div class="rounded-r-lg bg-vivid-royal-500 text-white px-2">{{data.client_number}}</div>
          </div>
          <div class="flex">
            <div class="rounded-l-lg bg-vivid-royal-800 text-white px-2">Dispositivo</div>
            <div class="rounded-r-lg bg-vivid-royal-500 text-white px-2">{{data.vehicle}}</div>
          </div>
        </div>

        @if (contact?.legalName) {
          <p class="text-center text-sm text-gray-900 mt-2 font-bold">{{ contact.company }}</p>
          <p class="text-center text-xs text-gray-800 font-normal">{{ contact.legalName }}</p>
        <p class="text-xs text-gray-500 mt-1">Atención a clientes</p>
        <a [href]="contact.phoneLink" class="text-sm font-semibold text-vivid-royal-600">{{ contact.phone }}</a>
        }

      } @else {
        <div class="flex flex-col items-center justify-center mt-8 px-4">
          <div class="bg-white rounded-xl shadow-md p-8 max-w-sm w-full text-center">
            <i class="pi pi-exclamation-circle text-5xl text-red-400 mb-4"></i>
            <h2 class="text-lg font-semibold text-gray-800 mb-2">Código no disponible</h2>
            <p class="text-sm text-gray-600">{{ data.message }}</p>
            @if (contact?.phone) {
              <div class="mt-4 pt-4 border-t border-gray-100">
                <p class="text-xs text-gray-500">{{ contact.company }}</p>
                <p class="text-xs text-gray-500">{{ contact.legalName }}</p>
                <p class="text-xs text-gray-500 mt-1">Atención a clientes</p>
                <a [href]="contact.phoneLink" class="text-sm font-semibold text-vivid-royal-600">{{ contact.phone }}</a>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
</div>
